import {
  EMPLOYEES_SHIFTHISTORY_FETCHING,
  EMPLOYEES_SHIFTHISTORY_SUCCESS,
  EMPLOYEES_SHIFTHISTORY_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_SHIFTHISTORY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEES_SHIFTHISTORY_FAILED:
      return { ...state, result: null, isFetching: false, isError: false };
    case EMPLOYEES_SHIFTHISTORY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
